import { render } from "./my-subscribe.vue?vue&type=template&id=8f214a0c&scoped=true&ts=true"
import script from "./my-subscribe.vue?vue&type=script&lang=ts"
export * from "./my-subscribe.vue?vue&type=script&lang=ts"

import "./my-subscribe.vue?vue&type=style&index=0&id=8f214a0c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f214a0c"]])

export default __exports__